export default __webpack_public_path__ + "static/media/ic_map_eu_hub.7d7bc883.svg";